export var DisputeFeature;
(function (DisputeFeature) {
    DisputeFeature["Questionnaire"] = "questionnaire";
    DisputeFeature["DisputeCenter"] = "disputeCenter";
    DisputeFeature["Eligibility"] = "eligibility";
    DisputeFeature["Chat"] = "chat";
    DisputeFeature["UploadDocuments"] = "uploadDocuments";
})(DisputeFeature || (DisputeFeature = {}));
//# sourceMappingURL=typings.js.map